window.SkillsForm = function(scope, registrationApi, jobId, hUser) {
    var self = this;
    var formName = "skills-form";
    self.name = formName;
    self.status = {loading: true, completed: false};
    var _protected = BaseForm.call(self, formName, scope);

    self.skills = [];
    
    self.isOptional = function () {
        return !self.type;
    };

    if (!jobId) {
        registrationApi.getSkillLookup()
            .then(function (res) {
                self.skillsList = res;
            });
    }

    self.load = function() {
        var defer = $q.defer();

        if(!jobId) {
            SkillsAPI.getUserSkills()
                .then(function(skills){
                    self.data.skills = skills;
                    setTimeout(function() {
                        self.calculateCompleteness();
                    }, 1000);
                    self.status.loading = false;
                    defer.resolve();
                });
        } else {
            JobApplicationAPI.getJobDetails(jobId).then(function (data) {
                self.skillsList = data.job.Skill;
                setTimeout(function() {
                    self.calculateCompleteness();
                }, 1000);
                self.status.loading = false;
                defer.resolve();
            });
        }

        return defer.promise;
    };

    self.save = function() {
        var defer = $q.defer();

        var skills = self.data.skills || [];
        SkillsAPI.saveUserSkills(skills)
            .then(function(res) {
                defer.resolve(res);
            },
            function(err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.validator.afterValidation(function () {
        setTimeout(function() {
            self.calculateCompleteness();
        }, 100)
    });

    self.calculateCompleteness = function () {
        self.status.completed = self.isOptional() || (self.data.skills && self.data.skills.length >= 3);

        if (scope) {
            try {
                scope.$digest();
            }
            catch (e) { /* Do Nothing */ }
        }
        else {
            console.warn("Scope is not here: form name: ", name);
        }
    }

}
